export enum NotAvailableMessageTextLength {
    long = 'long',
    short = 'short',
}

export interface NotAvailableMessageBoxProps {
    readonly textLength: NotAvailableMessageTextLength;
}
